import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import './Naime.css';
import Sidebar from './Sidebar/Sidebar';

const Naime = () => {

    const [isHere, setIsHere] = useState('');
    const location = useLocation();
    useEffect(() => {
        setIsHere(location.pathname);
    }, [location.pathname]);

    return (
        <div className={isHere === '/projects'? 'naime__style_scroll': 'naime__style'}>
            <Sidebar />
            <div>
                <Outlet />
            </div>
        </div>
    );
};

export default Naime;